// extracted by mini-css-extract-plugin
export default {"titleWrapper":"_1GnSS","titleWrapperInFeed":"_1xu0d","title":"_1-_-y"};